import { AxiosResponse } from 'axios';
import { playerOnlineList, playerOnlineLogout, playerOnlineReload } from '@/api/playerOnline';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IPlayerOnlineApiListResponse, IPlayerOnlineFilters, IPlayerOnlineLogoutParams, IPlayerOnlineReloadParams } from '@/types/playerOnline';

export const playerOnlineService = {
    async list(params: IListParams<IPlayerOnlineFilters>): Promise<AxiosResponse<IPlayerOnlineApiListResponse>> {
        try {
            return await baseListService<IPlayerOnlineApiListResponse>(playerOnlineList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('PlayerOnline API Error:', e);
            throw new AppError('Unable to load logged players list, request error', { cause: e });
        }
    },

    async reload(params: IPlayerOnlineReloadParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await playerOnlineReload(params);
        } catch (e) {
            console.error('PlayerOnline Reload API Error:', e);
            throw new AppError('Unable to reload logged players, request error', { cause: e });
        }
    },

    async logout(params: IPlayerOnlineLogoutParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await playerOnlineLogout(params);
        } catch (e) {
            console.error('PlayerOnline Logout API Error:', e);
            throw new AppError('Unable to logout logged players, request error', { cause: e });
        }
    },
};
